/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface CitasControllerMarcarCitaReprogramadaLeida$Params {

/**
 * Código de la cita a modificar
 */
  uuidCita: string;
}

export function citasControllerMarcarCitaReprogramadaLeida(http: HttpClient, rootUrl: string, params: CitasControllerMarcarCitaReprogramadaLeida$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, citasControllerMarcarCitaReprogramadaLeida.PATH, 'post');
  if (params) {
    rb.path('uuidCita', params.uuidCita, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

citasControllerMarcarCitaReprogramadaLeida.PATH = '/api/citas/marcar-cita-reprogramada-leida/{uuidCita}';
